<template>
  <div class="wrapper">
    <header class="header">
      <div class="container">
        <div class="header-content">
          <div class="logo">
            <img :src="logo" alt="Miracle White" />
          </div>
          <nav class="nav">
            <a href="#">About Us</a>
            <a href="#">NEW</a>
            <a href="#">Product</a>
            <a href="#">Product Authentication</a>
            <a href="#">Contact Us</a>
          </nav>
        </div>
      </div>
    </header>

    <main>
      <section class="verify-section">
        <div class="container">
          <h1>VERIFICATION</h1>
          <p>We appreciate your support and participation in this effort to eliminate counterfeit products.</p>
          
          <!-- 加载中状态 -->
          <div v-if="isLoading" class="verify-loading">
            <div class="spinner"></div>
            <p>Verifying product authenticity...</p>
          </div>
          
          <!-- 验证成功状态 -->
          <div v-else-if="verificationStatus === 'valid' && isFirstScan" class="verify-result success">
            <img :src="validIcon" alt="Valid" class="valid-icon" />
            <h2>Congratulations!</h2>
            <p>Your Miracle White product has been successfully verified as genuine.</p>
            <p>Thank you for choosing Hess & Co. Laboratories. You can now be assured.</p>
          </div>
          
          <!-- 已验证状态 -->
          <div v-else-if="verificationStatus === 'valid' && !isFirstScan" class="verify-result warning">
            <img :src="warningIcon" alt="Warning" class="warning-icon" />
            <h2>PRODUCT ALREADY VERIFIED</h2>
            <p>This authentic product has already been scanned before.</p>
            <p>If you did not scan this product previously, please contact customer service.</p>
          </div>
          
          <!-- 多次扫描警告状态 -->
          <div v-else-if="verificationStatus === 'warning'" class="verify-result warning">
            <img :src="warningIcon" alt="Warning" class="warning-icon" />
            <h2>MULTIPLE SCANS DETECTED</h2>
            <p>This product has been scanned multiple times.</p>
            <p>If you have concerns about the authenticity, please contact customer service.</p>
          </div>
          
          <!-- 验证失败状态 -->
          <div v-else-if="verificationStatus === 'invalid'" class="verify-result error">
            <img :src="invalidIcon" alt="Invalid" class="invalid-icon" />
            <h2>VERIFICATION FAILED</h2>
            <p>We could not verify this product as genuine.</p>
            <p>The product may be counterfeit or the verification code may be incorrect.</p>
          </div>
          
          <!-- 系统错误状态 -->
          <div v-else class="verify-result error">
            <img :src="errorIcon" alt="Error" class="error-icon" />
            <h2>SYSTEM ERROR</h2>
            <p>We encountered a problem during verification.</p>
            <p>Please try again later or contact customer service.</p>
          </div>
        </div>
      </section>

      <section v-if="verificationStatus === 'valid'" class="product-gallery">
        <div class="container">
          <h3>Miracle White packaging through the years</h3>
          <!-- 使用改进的轮播图组件 -->
          <ProductCarousel />
        </div>
      </section>

      <div class="button-section">
        <a href="#" class="cta-button">Our products</a>
      </div>
    </main>

    <footer>
      <div class="container">
        <p>© Copyright 2012 - 2023 | All Rights Reserved by Hess & Co.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import logo from '@/assets/MW-logo.png'
import validIcon from '@/assets/valid.png'
import warningIcon from '@/assets/invalid.png'  // 使用invalid.png代替warning.png
import invalidIcon from '@/assets/invalid.png'
import errorIcon from '@/assets/invalid.png'  // 使用invalid.png代替error.png
import ProductCarousel from './components/ProductCarousel.vue'

export default {
  name: 'App',
  components: {
    ProductCarousel
  },
  data() {
    return {
      logo,
      validIcon,
      warningIcon,
      invalidIcon,
      errorIcon,
      isLoading: false,
      verificationStatus: 'valid',
      isFirstScan: true,
      message: 'Product verified successfully'
    }
  },
  methods: {
    async verifyCode() {
      this.isLoading = true;

      try {
        // 从URL获取验证码
        const code = window.location.pathname.split('/').pop();
        
        // 调用验证API
        const response = await fetch(`/api/verify/${code}`);
        const data = await response.json();
        
        // 根据API的响应设置验证状态
        if (data.status === 'success' && data.is_first_scan) {
          this.verificationStatus = 'valid';
          this.isFirstScan = true;
        } else if (data.status === 'warning' || (data.status === 'success' && !data.is_first_scan)) {
          this.verificationStatus = 'valid';
          this.isFirstScan = false;
        } else if (data.code_status === 'invalid') {
          this.verificationStatus = 'invalid';
        } else {
          this.verificationStatus = 'error';
        }
        
        this.message = data.message;
      } catch (error) {
        console.error('Verification error:', error);
        this.verificationStatus = 'error';
        this.message = 'System error occurred';
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    // 执行验证
    const path = window.location.pathname;
    if (path === '/' || path === '') {
      // 首页显示验证失败
      this.isLoading = false;
      this.verificationStatus = 'invalid';
    } else {
      // 有验证码的路径，执行验证
      this.verifyCode();
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.header {
  padding: 20px 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo img {
  height: 60px;
}

.nav {
  display: flex;
  gap: 30px;
}

.nav a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
}

.verify-section {
  text-align: center;
  padding: 60px 0;
  background: #f5f5f5;
}

.verify-section h1 {
  font-size: 36px;
  margin-bottom: 20px;
}

.verify-loading {
  margin-top: 40px;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #333;
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.verify-result {
  margin-top: 40px;
  padding: 30px;
  border-radius: 8px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.verify-result.success {
  background-color: #e8f5e9;
  border: 1px solid #a5d6a7;
}

.verify-result.warning {
  background-color: #fff8e1;
  border: 1px solid #ffecb3;
}

.verify-result.error {
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
}

.valid-icon, .warning-icon, .invalid-icon, .error-icon {
  width: 80px;
  margin-bottom: 20px;
}

.verify-result h2 {
  margin-bottom: 15px;
}

.product-gallery {
  padding: 60px 0;
}

.product-gallery h3 {
  text-align: center;
  margin-bottom: 40px;
}

.button-section {
  text-align: center;
  padding: 40px 0;
}

.cta-button {
  display: inline-block;
  padding: 12px 30px;
  background: #333;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 18px;
}

footer {
  margin-top: auto;
  background: #333;
  color: white;
  padding: 20px 0;
  text-align: center;
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 20px;
  }
  
  .nav {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
}
</style>